<script>
import MinionTable from "@/components/CMS/Sub-component/Minion/MinionTable.vue"
import MinionSaveModal from "@/components/CMS/Sub-component/Minion/MinionSaveModal.vue"

export default {
  name: "MinionEdit",
  components: { MinionSaveModal, MinionTable },
  props: {
    agentId: [Number, String],
    isActive: Boolean,
  },
  data() {
    return {
      isLoading: false,
      dialogIsVisible: false,
      data: [],
      minionTypes: []
    }
  },
  watch: {
    isActive(newValue) {
      if (newValue) this.getMinions()
      this.getTypes()
    },
  },
  methods: {
    async getMinions() {
      this.isLoading = true
      try {
        const { data } = await this.$axios.get(`admin/agents/${this.agentId}/minions`)
        this.data = data?.data || []
      } catch (e) {
        throw new Error(e)
      } finally {
        this.isLoading = false
      }
    },
    async getTypes() {
      try {
        const { data } = await this.$axios.get(`admin/minions/create`)
        this.minionTypes = data?.data || []
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async turnOffMinion(minionId) {
      if(!minionId) return
      try {
        await this.$axios.delete('admin/minions/' + minionId)
        await this.getMinions()
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async turnOnMinion(minionId) {
      if(!minionId) return
      try {
        await this.$axios.post('admin/minions/' + minionId + '/restore')
        await this.getMinions()
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    onChangeStatus(minionId, status) {
      if(!status) this.turnOffMinion(minionId)
      else this.turnOnMinion(minionId)
    }
  }
}
</script>

<template>
  <div class="has-background-white p-5 is-relative" style="min-height: 100px">
    <b-loading v-model="isLoading" :is-full-page="false" />
    <div class="is-flex is-justify-content-space-between is-align-items-center mb-5">
      <h2 class="is-size-5 has-text-weight-semibold">Minions</h2>
      <b-button
        type="is-info"
        size="is-small"
        :disabled="isLoading"
        @click="dialogIsVisible = true"
      >+ Добавить</b-button>
    </div>
    <MinionTable :data="data" :loading="isLoading" @changeStatus="onChangeStatus" />
    <MinionSaveModal :is-visible.sync="dialogIsVisible" :agent-id="this.agentId" :types="minionTypes" @refresh="getMinions" />
  </div>
</template>

<style scoped>

</style>
